export default function PlaceholderPage(){
    return(
        <>
        <h2>This page is under construction</h2>
        </>
    )
}